<template>
  <div class="panel-body panel-table">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: "panel-table"
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Panel/PanelTable.vue